export type PrintTone = "muted" | "faint" | "strong";

export const PRINT_TONE: Record<PrintTone, string> = {
  muted: "text-secondary",
  faint: "text-dark/40",
  strong: "text-default",
};
